/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useRef } from 'preact/hooks';
import { OverviewProps } from './overview.types';
import { styles } from './themes/VisOverview.css';
import { useOverviewEvents } from './useOverviewEvents';
import { OverviewHorizontalDragHandleIcon } from '#PRIVATE_ThemedIcons/OverviewHorizontalDragHandleIcon';
import { isTouch } from '#utils/UNSAFE_visUtils/clientUtils';

const OVERVIEW_HANDLE_SIZE = 16;
const OVERVIEW_HANDLE_ACTIVATION_SIZE = isTouch() ? 30 : 10;

export function OverviewSlidingWindow({
  x,
  width,
  height,
  y,
  windowX,
  windowHeight,
  windowWidth,
  windowY,
  hasHandles,
  onWindowDimsChange
}: OverviewProps) {
  const rootRef = useRef(null);
  const overviewProps = useOverviewEvents({
    x,
    y,
    width,
    height,
    windowHeight,
    windowWidth,
    windowX,
    windowY,
    rootRef,
    onWindowDimsChange
  });
  const handleIconY = windowY + 0.5 * (windowHeight - OVERVIEW_HANDLE_SIZE);
  return (
    <g ref={rootRef} {...(hasHandles ? overviewProps : {})}>
      <rect x={x} y={y} width={width} height={height} fill="transparent"></rect>
      <rect
        data-oj-private-object="window"
        cursor="move"
        x={windowX}
        y={windowY}
        height={windowHeight - 1}
        width={windowWidth - 1}
        class={styles.overviewWindow}></rect>
      {hasHandles && (
        <>
          <g transform={`translate(${windowX} ${handleIconY})`}>
            <OverviewHorizontalDragHandleIcon color="primary" />
          </g>

          <g
            transform={`translate(${windowX + windowWidth - OVERVIEW_HANDLE_SIZE} ${handleIconY})`}>
            <OverviewHorizontalDragHandleIcon color="primary" />
          </g>

          <rect
            x={windowX}
            y={windowY}
            height={windowHeight}
            width={OVERVIEW_HANDLE_ACTIVATION_SIZE}
            strokeWidth="1"
            data-oj-private-object="leftHandle"
            fill="transparent"
            stroke="transparent"
            cursor="col-resize"></rect>
          <rect
            x={windowX + windowWidth - OVERVIEW_HANDLE_ACTIVATION_SIZE}
            y={windowY}
            strokeWidth="1"
            height={windowHeight}
            data-oj-private-object="rightHandle"
            width={OVERVIEW_HANDLE_ACTIVATION_SIZE}
            stroke="transparent"
            fill="transparent"
            cursor="col-resize"></rect>
        </>
      )}
    </g>
  );
}
